import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {mergeMap, switchMap, tap} from 'rxjs/operators';
import {of} from 'rxjs';
import {Store} from '@ngrx/store';
import {Title} from '@angular/platform-browser';
import {exitCampaign, selectCurrentCampaign, unauthenticated, userLoad} from 'gamesis-state';


@Injectable()
export class AppEffects {
    setTitle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(userLoad),
            switchMap(_ => this.store.select(selectCurrentCampaign)),
            tap((campaign) => {
                this.titleService.setTitle(campaign ? campaign?.name : 'ga.me.sis');
            })
        ), {dispatch: false}
    );

    exitCampaign$ = createEffect(() =>
        this.actions$.pipe(
            ofType(unauthenticated),
            mergeMap((_) => of(exitCampaign()))
        )
    );

    constructor(
        private actions$: Actions,
        private store: Store,
        private titleService: Title
    ) {
    }
}
